import { AppBar, Toolbar, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const SAppBar = styled(AppBar)`
  && {
    background-color: ${({ theme }) => theme.colors.bgPrimary};
    color: ${({ theme }) => theme.colors.textDefault};
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);

    .MuiToolbar-root {
      min-height: 56px;
    }
  }
`;

export const SMenuItem = styled(Typography)`
  && {
    color: ${({ theme }) => theme.colors.textDefault};
    margin: 0;
    padding: 0;
    padding-left: 90px;
    font-weight: 700;
  }
`;

export const SLink = styled(Link)`
  && {
    text-decoration: none;
    color: black;
  }
`;

export const SToolbar = styled(Toolbar)`
  && {
    margin-right: 0;
    padding-right: 0 !important;
  }
`;

export const SLogoImg = styled.img`
  && {
    height: 56px;
  }
`;
